/* eslint-disable */
import React, { useEffect } from 'react';

import { Downgraded, useState } from '@hookstate/core';
import { Box, CircularProgress, Tooltip, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
import { TextField, InputAdornment } from '@mui/material';
import { participantStatus, MODULE_LIST } from '../../constants/Constant';
import { getStatus } from '../../constants/Constant';
import CircleIcon from '@mui/icons-material/Circle';
import Title from '../../sharedcomponents/title/title';
import CachedIcon from '@mui/icons-material/Cached';
import ExportExcelIcon from '../../sharedcomponents/customIcons/exportExcelIcon';
import ModuleStatusIndicator from './moduleStatusIndicator';
import ModuleHeaderCount from './moduleHeaderCount';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    contentBox: {
        width: '100%',
        height: '100%',
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: '#fff',
        // border: '1px solid #efefef',
    },
    paperContent: {
        // boxShadow:
        //     'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        // border: '1px solid #efefef',
        // width: '100%'
    },
    cardContent: {
        padding: '5px',
        '&:last-child': {
            paddingBottom: '5px',
        },
    },

    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        color: '#fff',
        fontWeight: 500,
        fontSize: '0.65em',
    },
}));

const ParticipantModuleStatus = () => {
    const classes = useStyles();
    const userList = useState([]);
    const userFilterList = useState(null);
    const userAllFilteredList = useState([]);
    const headerModuleList = useState([]);
    const searchField = useState('');
    const loading = useState(false);
    const eventInfo = Helper.getStorage('eventInfo');
    const setModule = useState('');
    const setStatus = useState('');
    const draftHotelList = useState([]);
    const draftTransportList = useState([]);
    const credentialsList = useState([]);
    const greenRoomList = useState([]);
    const lunchRoomList = useState([]);
    const draftFlightList = useState([]);
    // console.log(draftHotelList.get());
    // console.log(userFilterList.get());

    useEffect(() => {
        getEventAllUserList();
    }, []);

    const getEventAllUserList = () => {
        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_EVENT_ALL_USER_MODULE_STATUS(eventInfo.eventID)
        )
            .then((res) => {
                const newModuleStatus = res.data.moduleStatus.filter(
                    (val) => (val.moduleName !== 'MediaCircuit' && val.moduleName !== 'ContentCircuit')
                );
                let result = newModuleStatus.reduce(function (r, c) {
                    r[c.userID] = r[c.userID] || {
                        userID: c.userID,
                        firstName: c.firstName,
                        lastName: c.lastName,
                        roleName: c.roleName,
                        userTags: c.userTags,
                        modules: [],
                    };
                    r[c.userID].modules.push({
                        module: c.module,
                        status: c.status,
                        requestStatus: c.requestStatus,
                        noAccess: c.noAccess,
                        moduleName: c.moduleName,
                    });
                    return r;
                }, {});
                let resultFilters = Object.values(result).filter((row) => {
                    const modCount = row.modules.length;
                    let noAccess = row.modules.filter(
                        (mod) => mod.noAccess == 1
                    );
                    if (modCount != noAccess.length) {
                        return row;
                    }
                });

                // console.log('----------->', Object.values(resultFilters));
                let result1 = newModuleStatus.reduce(function (r, c) {
                    r[c.module] = r[c.module] || {
                        module: c.module,
                        moduleName: c.moduleName,
                        status: c.status,
                        modules: [],
                    };
                    r[c.module].modules.push({
                        requestStatus: c.requestStatus,
                        noAccess: c.noAccess,
                        moduleName: c.moduleName,
                    });
                    return r;
                }, {});

                let HeaderModuleStatus = Object.values(result1).map((key) => {
                    return getModuleHeaderStatus(key);
                });
                //console.log('HeaderModuleStatus : ', HeaderModuleStatus);
                //console.log('resultFilters : ', resultFilters);
                let finalData = resultFilters.map((el) => {
                    if (el.modules.length != HeaderModuleStatus.length) {
                        HeaderModuleStatus.map((header, key) => {
                            if (
                                el.modules.some(
                                    (some) => some.module != header.module
                                )
                            ) {
                                let data = {
                                    module: header.module,
                                    noAccess: 1,
                                    moduleName: '',
                                    requestStatus: 0,
                                    status: 'To Do',
                                };
                                const index = el.modules.findIndex(
                                    (object) => object.module === header.module
                                );
                                if (index === -1) {
                                    el.modules.splice(key, 0, data);
                                }
                            }
                        });
                        return el;
                    } else {
                        return el;
                    }
                });

                if (res.data.drafthotelStatus.length > 0) {
                    let hotelModuleStatus = getModuleStatus(res.data.drafthotelStatus, finalData);
                    draftHotelList.set(hotelModuleStatus);
                }

                if (res.data.transportStatus.length > 0) {
                    let transportModuleStatus = getModuleStatus(res.data.transportStatus, finalData);
                    draftTransportList.set(transportModuleStatus);
                }
                if (res.data.credentialStatus.length > 0) {
                    let credentialModuleStatus = getModuleStatus(res.data.credentialStatus, finalData);
                    credentialsList.set(credentialModuleStatus);
                }

                if (res.data.greenRoomStatus.length > 0) {
                    let greenRoomModuleStatus = getModuleStatus(res.data.greenRoomStatus, finalData);
                    greenRoomList.set(greenRoomModuleStatus);
                }

                if (res.data.lunchRoomStatus.length > 0) {
                    let lunchRoomModuleStatus = getModuleStatus(res.data.lunchRoomStatus, finalData);
                    lunchRoomList.set(lunchRoomModuleStatus);
                }

                if (res.data.draftFlightStatus.length > 0) {
                    let draftFlightModuleStatus = getModuleStatus(res.data.draftFlightStatus, finalData);
                    draftFlightList.set(draftFlightModuleStatus);
                }

                let newHeaderStatus = []

                HeaderModuleStatus.map((data) => {
                    //console.log("data", data);
                    let statusCountObj;
                    if (data.moduleName.toLowerCase() === MODULE_LIST[0].toLowerCase() || data.moduleName.toLowerCase() === MODULE_LIST[10].toLowerCase()) {
                        statusCountObj = getModuleRequestStatusCount(data, res.data.transportStatus, data.module, data.moduleName);
                    }
                    else if (data.moduleName.toLowerCase() === MODULE_LIST[12].toLowerCase()) {
                        statusCountObj = getModuleRequestStatusCount(data, res.data.credentialStatus, data.module, data.moduleName);
                    }
                    else if (data.moduleName.toLowerCase() === MODULE_LIST[4].toLowerCase() ||
                        data.moduleName.toLowerCase() === MODULE_LIST[7].toLowerCase() ||
                        data.moduleName.toLowerCase() === MODULE_LIST[9].toLowerCase()) {
                        statusCountObj = getModuleRequestStatusCount(data, res.data.drafthotelStatus, data.module, data.moduleName);
                    }
                    else if (data.moduleName.toLowerCase() === MODULE_LIST[13].toLowerCase()) {
                        statusCountObj = getModuleRequestStatusCount(data, res.data.greenRoomStatus, data.module, data.moduleName);
                    }
                    else if (data.moduleName.toLowerCase() === MODULE_LIST[14].toLowerCase()) {
                        statusCountObj = getModuleRequestStatusCount(data, res.data.lunchRoomStatus, data.module, data.moduleName);
                    }
                    else if (data.moduleName.toLowerCase() === MODULE_LIST[15].toLowerCase()) {
                        statusCountObj = getModuleRequestStatusCount(data, res.data.draftFlightStatus, data.module, data.moduleName);
                    }
                    else {
                        statusCountObj = data;
                    }
                    newHeaderStatus.push(statusCountObj ? statusCountObj : data);
                })
                //console.log("asdasdasd", newHeaderStatus, Object.values(finalData), newCredObj.attach(Downgraded).get(), newHotelObj.attach(Downgraded).get());
                headerModuleList.set(newHeaderStatus);
                // headerModuleList.set(HeaderModuleStatus);
                userList.set(Object.values(finalData));
                userAllFilteredList.set(Object.values(finalData));
                userFilterList.set(Object.values(finalData));
                // draftHotelList.set(res.data.drafthotelStatus);
                // draftTransportList.set(res.data.transportStatus);

                loading.set(false);
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const getModuleRequestStatusCount = (headerData, data, moduleDisplayName, moduleName) => {
        let todoCounter = 0;
        let approvedCounter = 0;
        let pendingCounter = 0;
        let rejectCounter = 0;
    
        data.forEach((key) => {
            if (key.requestStatus === 0) {
                todoCounter += 1;
            } else if (key.requestStatus === 1) {
                pendingCounter += 1;
            } else if (key.requestStatus === 2) {
                approvedCounter += 1;
            } else {
                rejectCounter += 1;
            }
        });
    
        const statusObj = {
            approvedCount: 0,
            module: moduleDisplayName,
            moduleName: moduleName,
            pendingCount: 0,
            rejectCount: 0,
            todoCount: 0,
            participantpendingcount: 0,
            participantrejectcount: 0,
            participanttodocount: 0,
            participantapprovedcount: 0,
        };
    
        if (headerData && headerData.pendingCount === pendingCounter) {
            statusObj.pendingCount = headerData.pendingCount;
        } else {
            statusObj.pendingCount = pendingCounter;
        }
        if (headerData && headerData.approvedCount === approvedCounter) {
            statusObj.approvedCount = headerData.approvedCount;
        } else {
            statusObj.approvedCount = approvedCounter;
        }
        if (headerData && headerData.rejectCount === rejectCounter) {
            statusObj.rejectCount = headerData.rejectCount + rejectCounter;
        } else {
            statusObj.rejectCount = rejectCounter;
        }
        statusObj.todoCount = statusObj.todoCount;
    
        let participantTodoSet = new Set();
        let participantApprovedSet = new Set();
        let participantPendingSet = new Set();
        let participantRejectSet = new Set();
    
        data.forEach((key) => {
            if (key.requestStatus === 0) {
                participantTodoSet.add(key.userID);
            } else if (key.requestStatus === 1) {
                participantPendingSet.add(key.userID);
            } else if (key.requestStatus === 2) {
                participantApprovedSet.add(key.userID);
            } else {
                participantRejectSet.add(key.userID);
            }
        });
    
        statusObj.participantpendingcount = participantPendingSet.size;
        statusObj.participantrejectcount = participantRejectSet.size;
        statusObj.participanttodocount = participantTodoSet.size;
        statusObj.participantapprovedcount = participantApprovedSet.size;

        return statusObj;
    };
    
    
    
    
    

    const getModuleStatus = (data, finalData) => {
        let result = data.reduce(
            function (r, c) {
                r[c.userID] = r[c.userID] || {
                    userID: c.userID,
                    modules: [],
                };
                r[c.userID].modules.push({
                    requestStatus: c.requestStatus,
                    noAccess: 0,
                });

                return r;
            },
            {}
        );
        let moduleStatus = Object.values(
            result
        ).map((key) => {
            return getModuleHeaderStatus(key);
        });

        let difference = Object.values(finalData).filter(
            ({ userID: id1 }) =>
                !moduleStatus.some(
                    ({ module: id2 }) => id2 === id1
                )
        );
        Array.prototype.push.apply(
            moduleStatus,
            difference
        );
        return moduleStatus;
    }


    // let headerData = [];
    const getModuleHeaderStatus = (data) => {
        let todoCounter = 0;
        let approvedCounter = 0;
        let pendingCounter = 0;
        let rejectCounter = 0;
        if (data) {
            // console.log("data.modules",data.modules);
            data.modules.map((key) => {
                if (key.requestStatus === 0 && key.noAccess === 0) {
                    todoCounter += 1;
                } else if (key.requestStatus === 1 && key.noAccess === 0) {
                    pendingCounter += 1;
                } else if (key.requestStatus === 2 && key.noAccess === 0) {
                    approvedCounter += 1;
                } else {
                    rejectCounter += 1;
                }
            });
            // console.log("data.modules",data,rejectCounter);

            return {
                module: data.module ? data.module : data.userID,
                moduleName: data.moduleName ? data.moduleName : data.userID,
                todoCount: todoCounter,
                approvedCount: approvedCounter,
                pendingCount: pendingCounter,
                rejectCount: rejectCounter,
            };
        }
    };

    // const onModuleClick = (val, status, optionStatus) => {
    //     console.log("OnmoduleClick",val, status, optionStatus);
    //     setModule.set(val.module);
    //     setStatus.set(optionStatus);

    //     let array1 = userAllFilteredList.attach(Downgraded).get();
    //     let array

    //     if(val.module == 'Hotel'){
    //         setStatus.set("");
    //         array = getHotelStatus(val, array1,status);
    //     }
    //     else if(val.module == 'Credential'){
    //         setStatus.set("");
    //         array = getCredentialStatus(val, array1,status);
    //     }
    //     else{
    //         array1 = userAllFilteredList.attach(Downgraded).get();
    //         setStatus.set(optionStatus);
    //         array = array1 ;
    //     }
    //     console.log("array",array);
    //     const filteredResult = array.filter((item) => {
    //         let array = [];
    //         array = item.modules;
    //         let filterTrue = Boolean(
    //             array.some(
    //                 (x) =>
    //                     x.module === val.module &&
    //                     x.status === status &&
    //                     x.noAccess != 1
    //             )
    //         );
    //         if (filterTrue) {
    //             return item;
    //         }
    //     });
    //     userFilterList.set(filteredResult);
    // };
    const onModuleClick = (val, status, optionStatus) => {
        //console.log("asdasd", val, status, optionStatus);
        setModule.set(val.module);
        setStatus.set(optionStatus);
        let array = userAllFilteredList.attach(Downgraded).get();

        const filteredResult = array.filter((item) => {
            let array = [];
            let isDataExist = false;
            array = item.modules;
            let filterTrue = false;

            let listData = getModuleData(val.moduleName);
            //below code is added for filtering module with multiple allotments
            if (listData && listData.length > 0) {
                let data = listData.find(i => i.module === item.userID);
                if (data) {
                    if (optionStatus === 0 && (data.todoCount > 0 || data.rejectCount > 0)) {
                        isDataExist = true;
                    }
                    if (optionStatus === 1 && data.pendingCount > 0) {
                        isDataExist = true;
                    }
                    if (optionStatus === 2 && data.approvedCount > 0) {
                        isDataExist = true;
                    }
                    if (isDataExist && item.modules && item.requestStatus !== optionStatus) {
                        item.modules.forEach(i => {
                            if (i.moduleName === val.moduleName) {
                                i.requestStatus = optionStatus;
                            }
                        })
                    }
                    //added for TO Do status
                    if (!isDataExist && optionStatus === 0) {
                        filterTrue = checkModuleDataExist(array, val, status);
                    }
                }
                else {
                    if (!isDataExist && optionStatus === 0) {
                        filterTrue = checkModuleDataExist(array, val, status);
                    }
                }
            }
            else {
                filterTrue = checkModuleDataExist(array, val, status);
            }

            if (filterTrue || isDataExist) {
                return item;
            }
        });
        userFilterList.set(filteredResult);
    };

    const checkModuleDataExist = (array, val, status) => {
        const newArray =  array.filter((item => item.status !== 'To Do'));
        let filterTrue = Boolean(
            newArray.some(
                (x) =>
                    x.module === val.module &&
                    x.status === status &&
                    x.noAccess != 1
            )
        );
        return filterTrue;
    }

    const onTotalClick = (val) => {
        // console.log("asdasd val",val);
        setModule.set('');
        setStatus.set('');
        let array = userAllFilteredList.attach(Downgraded).get();
        // console.log("array",array);
        const filteredResult = array.filter((item) => {
            let array = [];
            array = item.modules;
            let filterTrue = Boolean(
                array.some((x) => x.module === val.module && x.noAccess != 1)
            );
            if (filterTrue) {
                return item;
            }
        });
        userFilterList.set(filteredResult);
    };

    const handleSearch = (e) => {
        searchField.set(e.target.value);
        let filterStore = [];
        if (e.target.value && userList.get()) {
            userList.forEach((item) => {
                let keys = Object.keys(item);
                let data = item.attach(Downgraded).get();

                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key]
                            .toLowerCase()
                            .indexOf(e.target.value.toLowerCase()) > -1
                    ) {
                        if (filterStore.indexOf(item) == -1)
                            filterStore.push(item.attach(Downgraded).get());
                    }
                });
            });
            if (filterStore.length > 0) {
                const key = 'userID';

                const modifyList = [
                    ...new Map(
                        filterStore.map((item) => [item[key], item])
                    ).values(),
                ];
                userFilterList.set(modifyList);
            }
        } else {
            userFilterList.set(JSON.parse(JSON.stringify(userList.get())));
        }
    };
    const resetFilter = () => {
        setModule.set('');
        setStatus.set('');
        userFilterList.set(userAllFilteredList.attach(Downgraded).get());
    };


    // console.log(headerModuleList.get());
    // console.log('TransportList', draftTransportList.attach(Downgraded).get());
    // console.log("draftHotelList",draftHotelList.attach(Downgraded).get());
    // console.log('USerFileer', userFilterList.attach(Downgraded).get());

    // console.log(userList.attach(Downgraded).get());

    const generateExcelReport = async () => {
        let data = [];
        let finalData = [];

        userFilterList
            .attach(Downgraded)
            .get()
            .map((key) => {
                data = {
                    Participant: key.firstName + ' ' + key.lastName,
                };
                key.modules &&
                    key.modules.length > 0 &&
                    key.modules.map((module) => {
                        if (module.moduleName == 'CombineRegistration' ||
                            module.moduleName == 'Outfit' ||
                            module.moduleName === 'SatNightTransport' ||
                            module.moduleName === 'DraftRegistration' ||
                            module.moduleName === 'AllStarRegistration' ||
                            module.moduleName === 'VIP' ||
                            module.moduleName === 'SocialResponsibility' ||
                            module.moduleName === 'AllStarTicket' ||
                            module.moduleName === 'CombineTransportation' ||
                            module.moduleName === 'Ticket' ||
                            module.moduleName === 'FlightInfo') {
                            data = {
                                ...data,
                                [module.module]:
                                    module.noAccess === 1
                                        ? ' '
                                        : module.status + ': 1',
                            };
                        }
                        else {
                            let approvedData = '';
                            let pendingData = '';
                            let toDoData = '';
                            let flag = false;
                            let listData = getModuleData(module.moduleName);

                            listData.map((status) => {
                                if (status.module === key.userID) {
                                    flag = true;
                                    // console.log('If=====>', key.firstName);
                                    if (
                                        status.todoCount > 0 ||
                                        status.rejectCount > 0
                                    ) {
                                        toDoData =
                                            ' To Do : ' +
                                            (status.todoCount +
                                                status.rejectCount);
                                    }

                                    if (status.pendingCount > 0) {
                                        pendingData =
                                            ' Pending : ' +
                                            status.pendingCount;
                                    }
                                    if (status.approvedCount > 0) {
                                        approvedData =
                                            ' Approved : ' +
                                            status.approvedCount;
                                    }

                                    const result = [];
                                    if (toDoData) {
                                        result.push(toDoData);
                                    }
                                    if (pendingData) {
                                        result.push(pendingData);
                                    }
                                    if (approvedData) {
                                        result.push(approvedData);
                                    }
                                    const results = result.join(' ,');
                                    // console.log(results);
                                    return (data = {
                                        ...data,
                                        [module.module]: results,
                                    });
                                } else {
                                    // console.log('else', flag);
                                    if (
                                        status.module !== key.userID &&
                                        !flag
                                    ) {
                                        return (data = {
                                            ...data,
                                            [module.module]:
                                                module.noAccess === 1
                                                    ? ' '
                                                    : module.status + ': 1',
                                        });
                                    }
                                }
                            });
                        }
                    });
                // console.log("data",data);
                finalData.push(data);
            });
        // let headernew = {};
        // headernew['Participant'] = 'Participant';
        // let modules = []
        //         headerModuleList.attach(Downgraded).get().map(item => {
        //             console.log(item)
        //             modules.push(item.module);
        //         });
        //         console.log('modules : ', modules)
        // const header = headernew;
        const objectTags = Object.fromEntries(headerModuleList.attach(Downgraded).get().map((t) => [t.module, t.module]))
        const header = Object.assign({ Participant: 'Participant' }, objectTags);
        // const header = {
        //     Participant: 'Participant',
        //     ' All Star Registration': 'All Star Registration',
        //     ' All Star Ticket': 'All Star Ticket',
        //     ' Flight Info': 'Flight Info',
        //     // ' Hotel': 'Hotel',
        //     // ' Outfit': 'Outfit',
        //     ' Player Hotel': 'Player Hotel',
        //     ' Saturday Night Transportation': 'Saturday Night Transportation',
        //     // ' Social Responsibility': 'Social Responsibility',
        //     // ' Tickets': 'Tickets',
        //     ' VIP': 'VIP',
        // };
        // console.log('data', data);
        // console.log('finaldata', finalData);

        finalData.unshift(header);
        // Helper.downloadStyledReport(finalData, `ParticipantStatus-Report`);

        Helper.downloadReport(finalData, `ParticipantStatus-Report`);
        // data.unshift(userList.attach(Downgraded).get());
        // Helper.downloadStyledReport(data, `ParticipantStatus-Report`);
        // Helper.downloadReport(data, `AllStarTickets-Report`);
    };
    // console.log(headerModuleList);

    const getModuleData = (moduleName) => {
        let listData = [];
        if (moduleName.toLowerCase() === MODULE_LIST[0].toLowerCase()
            || moduleName.toLowerCase() === MODULE_LIST[10].toLowerCase()) {
            listData = draftTransportList.attach(Downgraded).get();
        }
        else if (moduleName.toLowerCase() === MODULE_LIST[4].toLowerCase() ||
            moduleName.toLowerCase() === MODULE_LIST[7].toLowerCase() ||
            moduleName.toLowerCase() === MODULE_LIST[9].toLowerCase()) {
            listData = draftHotelList.attach(Downgraded).get();
        }
        else if (moduleName.toLowerCase() === MODULE_LIST[12].toLowerCase()) {
            listData = credentialsList.attach(Downgraded).get();
        }
        else if (moduleName.toLowerCase() === MODULE_LIST[13].toLowerCase()) {
            listData = greenRoomList.attach(Downgraded).get();
        }
        else if (moduleName.toLowerCase() === MODULE_LIST[14].toLowerCase()) {
            listData = lunchRoomList.attach(Downgraded).get();
        }
        else if (moduleName.toLowerCase() === MODULE_LIST[15].toLowerCase()) {
            listData = draftFlightList.attach(Downgraded).get();
        }
        return listData;
    }

    const renderModuleRequestStatus = (module, key, index) => {
        let listData = getModuleData(module.moduleName);

        return (
            <>
                {
                    module.moduleName && listData && listData.length > 0
                        ?
                        (
                            listData.map(
                                (
                                    status,
                                    index
                                ) => (
                                    <ModuleStatusIndicator key={index} status={status} keyProp={key} index={index} />
                                )
                            )
                        )
                        :
                        (
                            <Box
                                key={
                                    index
                                }
                                className={
                                    classes.wrapper
                                }
                                style={{
                                    fontSize: 16,
                                }}>
                                <CircleIcon
                                    style={{
                                        color: getStatus(
                                            module.requestStatus
                                        ),
                                    }}
                                    className={
                                        classes.icon
                                    }
                                />
                            </Box>
                        )
                }
            </>
        )
    }

    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className={classes.contentBox}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}>
                        <Title title={'Participant Status'} sx={{ ml: 0, px: 0, }} px={0} />
                        <Tooltip title={'Export Report'}>
                            <>
                                <IconButton
                                    color="primary"
                                    onClick={generateExcelReport}>
                                    <ExportExcelIcon
                                        fontSize="small"
                                        style={{ color: '#008000' }}
                                    />
                                </IconButton>
                            </>
                        </Tooltip>
                    </Box>
                    <Box sx={{ p: 1, width: { xs: '100%', md: '25%' } }}>
                        <TextField
                            value={searchField.value}
                            onChange={handleSearch}
                            size="small"
                            fullWidth={true}
                            placeholder="Search Participant"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            width:
                                headerModuleList.length < 8
                                    ? '100%'
                                    : 'max-content',
                        }}>
                        {headerModuleList.length > 0 &&
                            <ModuleHeaderCount headerModuleList={headerModuleList}
                                onModuleClick={onModuleClick}
                                onTotalClick={onTotalClick}
                                resetFilter={resetFilter} />
                        }
                        <Box sx={{ minWidth: 275 }}>
                            {userFilterList.length > 0 ? (
                                userFilterList
                                    .attach(Downgraded)
                                    .get()
                                    .map((key, index) => {
                                        return (
                                            <Card
                                                classes={{
                                                    root: classes.paperContent,
                                                }}
                                                variant="outlined"
                                                key={index}
                                                sx={{ mt: 2, mb: 2 }}>
                                                <CardContent
                                                    className={
                                                        classes.cardContent
                                                    }
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: {
                                                            xs: 'column',
                                                            md: 'row',
                                                        },
                                                    }}>
                                                    <Typography
                                                        fontSize={15}
                                                        fontWeight={700}
                                                        paddingTop={1.5}
                                                        color="text.secondary"
                                                        width={{
                                                            xs: '100%',
                                                            md: '10rem',
                                                        }}>
                                                        {key.firstName +
                                                            ' ' +
                                                            key.lastName}
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexWrap: 'nowrap',
                                                            flexDirection: {
                                                                xs: 'column',
                                                                md: 'row',
                                                            },
                                                            justifyContent:
                                                                'space-around',
                                                            width: '100%',
                                                        }}>
                                                        {key.modules &&
                                                            key.modules.length >
                                                            0 &&
                                                            key.modules.map(
                                                                (
                                                                    module,
                                                                    moduleIndex
                                                                ) => {
                                                                    return (
                                                                        <>
                                                                            {module.noAccess ===
                                                                                1 ? (
                                                                                <Box
                                                                                    key={
                                                                                        moduleIndex
                                                                                    }
                                                                                    sx={{
                                                                                        display:
                                                                                            'flex',
                                                                                        flexDirection:
                                                                                            'column ',
                                                                                        width: {
                                                                                            xs: '100%',
                                                                                            md: '10rem',
                                                                                            // key
                                                                                            //     .modules
                                                                                            //     .length ===
                                                                                            //     7
                                                                                            //     ? '14%'
                                                                                            //     : key
                                                                                            //         .modules
                                                                                            //         .length ===
                                                                                            //         6
                                                                                            //         ? '16%'
                                                                                            //         : key
                                                                                            //             .modules
                                                                                            //             .length ===
                                                                                            //             5
                                                                                            //             ? '19.5%'
                                                                                            //             : key
                                                                                            //                 .modules
                                                                                            //                 .length ===
                                                                                            //                 4
                                                                                            //                 ? '20%'
                                                                                            //                 : key
                                                                                            //                     .modules
                                                                                            //                     .length ===
                                                                                            //                     3
                                                                                            //                     ? '20%'
                                                                                            //                     : key
                                                                                            //                         .modules
                                                                                            //                         .length ===
                                                                                            //                         2
                                                                                            //                         ? '20%'
                                                                                            //                         : key
                                                                                            //                             .modules
                                                                                            //                             .length ===
                                                                                            //                             1
                                                                                            //                             ? '20%'
                                                                                            //                             : '',
                                                                                        },
                                                                                        opacity:
                                                                                            '0',
                                                                                    }}>
                                                                                    <Typography
                                                                                        sx={{
                                                                                            fontSize: 14,
                                                                                            fontWeight: 500,
                                                                                            color: 'primary.main',
                                                                                        }}
                                                                                        textAlign={
                                                                                            'center'
                                                                                        }>
                                                                                        {setModule
                                                                                            .attach(
                                                                                                Downgraded
                                                                                            )
                                                                                            .get() !==
                                                                                            ''
                                                                                            ? module.requestStatus !==
                                                                                                setStatus
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get() &&
                                                                                                module.module ===
                                                                                                setModule
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get()
                                                                                                ? ''
                                                                                                : module.module
                                                                                            : module.module}
                                                                                    </Typography>
                                                                                    <Box
                                                                                        sx={{
                                                                                            display:
                                                                                                'flex',
                                                                                            flexDirection:
                                                                                                'row',
                                                                                            justifyContent:
                                                                                                'center',
                                                                                            itemCenter:
                                                                                                'center',
                                                                                        }}>
                                                                                        {setStatus
                                                                                            .attach(
                                                                                                Downgraded
                                                                                            )
                                                                                            .get() !==
                                                                                            ''
                                                                                            ?
                                                                                            (module.requestStatus !==
                                                                                                setStatus
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get() &&
                                                                                                module.module ===
                                                                                                setModule
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get()
                                                                                                ? ''
                                                                                                : module.requestStatus !==
                                                                                                null &&
                                                                                                module.requestStatus !==
                                                                                                undefined &&
                                                                                                // <CircleIcon
                                                                                                //     fontSize="small"
                                                                                                //     style={{
                                                                                                //         color: getStatus(
                                                                                                //             module.requestStatus
                                                                                                //         ),
                                                                                                //     }}
                                                                                                // />

                                                                                                (
                                                                                                    renderModuleRequestStatus(module, key, moduleIndex)
                                                                                                )
                                                                                            )
                                                                                            : module.requestStatus !==
                                                                                            null &&
                                                                                            module.requestStatus !==
                                                                                            undefined &&
                                                                                            //   <CircleIcon
                                                                                            //       fontSize="small"
                                                                                            //       style={{
                                                                                            //           color: getStatus(
                                                                                            //               module.requestStatus
                                                                                            //           ),
                                                                                            //       }}
                                                                                            //   />
                                                                                            (
                                                                                                renderModuleRequestStatus(module, key, moduleIndex)
                                                                                            )
                                                                                        }
                                                                                    </Box>
                                                                                </Box>
                                                                            ) : (
                                                                                <Box
                                                                                    key={
                                                                                        moduleIndex
                                                                                    }
                                                                                    sx={{
                                                                                        display:
                                                                                            'flex',
                                                                                        flexDirection:
                                                                                            'column ',
                                                                                        width: {
                                                                                            xs: '100%',
                                                                                            md: '10rem',
                                                                                        },
                                                                                    }}>
                                                                                    <Typography
                                                                                        sx={{
                                                                                            fontSize: 14,
                                                                                            fontWeight: 500,
                                                                                            color: 'primary.main',
                                                                                        }}
                                                                                        textAlign={
                                                                                            'center'
                                                                                        }>
                                                                                        {setModule
                                                                                            .attach(
                                                                                                Downgraded
                                                                                            )
                                                                                            .get() !==
                                                                                            ''
                                                                                            ? module.requestStatus !==
                                                                                                setStatus
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get() &&
                                                                                                module.module ===
                                                                                                setModule
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get()
                                                                                                ? ''
                                                                                                : module.module
                                                                                            : module.module}
                                                                                    </Typography>
                                                                                    <Box
                                                                                        sx={{
                                                                                            display:
                                                                                                'flex',
                                                                                            flexDirection:
                                                                                                'row',
                                                                                            justifyContent:
                                                                                                'center',
                                                                                            itemCenter:
                                                                                                'center',
                                                                                        }}>
                                                                                        {setStatus
                                                                                            .attach(
                                                                                                Downgraded
                                                                                            )
                                                                                            .get() !==
                                                                                            '' ? (
                                                                                            module.requestStatus !==
                                                                                                setStatus
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get() &&
                                                                                                module.module ===
                                                                                                setModule
                                                                                                    .attach(
                                                                                                        Downgraded
                                                                                                    )
                                                                                                    .get() ? (
                                                                                                ''
                                                                                            ) : (
                                                                                                module.requestStatus !==
                                                                                                null &&
                                                                                                module.requestStatus !==
                                                                                                undefined &&
                                                                                                (
                                                                                                    renderModuleRequestStatus(module, key, moduleIndex)
                                                                                                )
                                                                                            )
                                                                                        ) : module.requestStatus !==
                                                                                        null &&
                                                                                        module.requestStatus !==
                                                                                        undefined &&
                                                                                        module.moduleName &&
                                                                                        (
                                                                                            renderModuleRequestStatus(module, key, moduleIndex)
                                                                                        )
                                                                                        }
                                                                                    </Box>
                                                                                </Box>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }
                                                            )}
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        );
                                    })
                            ) : (
                                userFilterList.get() != null && userFilterList.get().length == 0 ?
                                    <Card
                                        classes={{
                                            root: classes.paperContent,
                                        }}
                                        variant="outlined"
                                        sx={{ m: 2 }}>
                                        <CardContent
                                            className={classes.cardContent}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: {
                                                    xs: 'column',
                                                    md: 'row',
                                                },
                                            }}>
                                            <Box>No Data found</Box>
                                        </CardContent>
                                    </Card> : null
                            )}
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_PARTICIPANT_MODULE_STATUS,
        component: ParticipantModuleStatus,
    },
    name: 'ChangeUser',
};
